package com.shadowings.gero.util

import gero.composeapp.generated.resources.Res
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.khronos.webgl.Int8Array
import org.w3c.dom.Audio
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

actual object SoundPlayer {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)

    private var enabled: Boolean = true

    private val audioCache = mutableMapOf<String, Audio>()
    private val loadMutex = Mutex()

    actual fun setEnabled(enabled: Boolean) {
        this.enabled = enabled
    }

    actual fun playCorrect() = play("files/correct.mp3")
    actual fun playIncorrect() = play("files/wrong.mp3")
    actual fun playThreeErrors() = play("files/three_errors.mp3")
    actual fun playComboFive() = play("files/combo_five.mp3")
    actual fun playStreak() = play("files/streak.mp3")
    actual fun playNoHearts() = play("files/heart_break.mp3")

    actual fun playFinalStars(stars: Int) {
        play("files/stars_${stars.coerceIn(0, 3)}.mp3")
    }

    @OptIn(ExperimentalResourceApi::class)
    private fun play(resourcePath: String) {
        if (!enabled) return
        scope.launch {
            try {
                val audio = getOrLoadAudio(resourcePath) ?: return@launch
                if (!enabled) return@launch
                audio.currentTime = 0.0
                audio.play()
            } catch (_: Throwable) {
                // Quiet fallback to keep quiz flow responsive even if audio fails.
            }
        }
    }

    @OptIn(ExperimentalResourceApi::class)
    private suspend fun getOrLoadAudio(resourcePath: String): Audio? {
        audioCache[resourcePath]?.let { return it }
        return loadMutex.withLock {
            audioCache[resourcePath]?.let { return it }
            try {
                val bytes = Res.readBytes(resourcePath)
                val blob = Blob(
                    arrayOf(Int8Array(bytes.toTypedArray())),
                    BlobPropertyBag(type = "audio/mpeg")
                )
                val url = URL.createObjectURL(blob)
                Audio(url).also { audioCache[resourcePath] = it }
            } catch (_: Throwable) {
                null
            }
        }
    }
}
